import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as terapiaPlanService from "../../services/terapiaPlanService";
import * as terapiaService from "../../services/terapiaService";
import { obtenerPerfil } from "../../services/usuarioService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import TherapyPlan from '../../components/TherapyPlan'
import TherapyPlanArea from '../../components/TherapyPlanArea'
import TherapyPlanObjetivo from '../../components/TherapyPlanObjetivo'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { setEntity as setTherapyPlan, activeValidations as activeValidationsTherapyPlan } from '../../redux/therapyPlanSlice';
import { setEntity as setTherapyPlanArea, activeValidations as activeTherapyPlanArea } from '../../redux/therapyPlanAreaSlice';
import { setEntity as setTherapyPlanObjetivo, activeValidations as activeTherapyPlanObjetivo } from '../../redux/therapyPlanObjetivoSlice';

// Mantenimiento del plan de terapia del terapeuta: la ventana es la misma
// que la de supervision, pero el terapeuta registra planes de sus propias
// terapias. Su nombre va encima del titulo y la terapia se elige de su
// lista, sin vigencia ni estado.
const Edit = (props) => {
   const therapyPlan = useSelector((state) => state.therapyPlan.entity);
   const therapyPlanArea = useSelector((state) => state.therapyPlanArea.entity);
   const therapyPlanValidation = useSelector((state) => state.therapyPlan.validationMessage);
   const therapyPlanAreaValidation = useSelector((state) => state.therapyPlanArea.validationMessage);

   const defaultTherapyPlanArea = useSelector((state) => state.therapyPlanArea.defaultEntity)
const therapyPlanObjetivo = useSelector((state) => state.therapyPlanObjetivo.entity);
const therapyPlanObjetivoValidation = useSelector((state) => state.therapyPlanObjetivo.validationMessage);
const defaultTherapyPlanObjetivo = useSelector((state) => state.therapyPlanObjetivo.defaultEntity)
  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const [nombreTerapeuta, setNombreTerapeuta] = useState("");
  const [idTerapeuta, setIdTerapeuta] = useState(0);
  const dispatch = useDispatch();
  const params = useParams();
  // El terapeuta edita los planes de sus pacientes con
  // terapiaPlanTerapeuta.editar y la supervision con terapiaPlan.editar:
  // basta con tener una de las dos llaves.
  const { isReadOnly, setIsReadOnly } = useMantenimiento(["terapiaPlan", "terapiaPlanTerapeuta"]);

  // El terapeuta de esta pantalla es el usuario logueado: su persona sale de
  // su perfil, igual que en la navegabilidad de planes.
  useEffect(() => {
      obtenerPerfil()
          .then((perfil) => {
              setIdTerapeuta(perfil?.idPersona || 0);
              setNombreTerapeuta(perfil?.nombres || "");
          })
          .catch(() => null);
  }, [])

  const postEntity = async () => {
    // Cada fila del detalle necesita su modelo (obligatorio) y trae el area
    // como texto cuando el autocompletar la registro nueva en el modelo.
    var dataPost = {
      ...therapyPlan
      , terapiaPlanArea: (therapyPlanArea || []).map((row) => ({
          id: row.id,
          numero: row.numero,
          idModelo: row.idModelo,
          idArea: row.idArea,
          orden: row.orden,
          // Grupo de puntuacion que se elige en la fila del detalle.
          idPuntuacionGrupo: (row.idPuntuacionGrupo == null ? 0 : row.idPuntuacionGrupo),
          areaNueva: (row.idArea > 0 ? "" : (row.area || "")),
      }))
      // Los objetivos que se siguen en el plan: salen del catalogo de
      // objetivos de temas de evaluacion.
      , terapiaPlanObjetivo: (therapyPlanObjetivo || []).map((row) => ({
          id: row.id,
          numero: row.numero,
          idObjetivoCatalogo: row.idObjetivoCatalogo,
          orden: row.orden,
      }))
    }

    var ValidationMessages = therapyPlanValidation.concat(therapyPlanAreaValidation).concat(therapyPlanObjetivoValidation)

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsTherapyPlan());
      dispatch(activeTherapyPlanArea());
      dispatch(activeTherapyPlanObjetivo());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await terapiaPlanService.addUpdateTerapiaPlanWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          const idGuardado = (therapyPlan.id > 0) ? therapyPlan.id : (response?.data?.data || 0);

          if (idGuardado > 0){
            terapiaPlanService.getTerapiaPlanView(idGuardado)
            .then(data => {
                if (data != null) dispatch(setTherapyPlan(data));
            })
            .catch((err) => { console.log("Err: ", err); });

            terapiaService.getsTerapiaPlanAreaView(idGuardado)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapyPlanArea(defaultTherapyPlanArea));
              else
                dispatch(setTherapyPlanArea(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            terapiaPlanService.getsTerapiaPlanObjetivoView(idGuardado)
            .then(data => dispatch(setTherapyPlanObjetivo((data && data.length > 0)
                ? data : defaultTherapyPlanObjetivo)))
            .catch((err) => {
              console.log("Err: ", err);
            });
          }
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nuevo" : "Editar") + " Plan de Terapia"}
        subtitle={nombreTerapeuta}
        backTo={"/therapyplanterapist"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyPlan isReadOnly={isReadOnly} modoTerapeuta={true} idTerapeuta={idTerapeuta} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyPlanArea isReadOnly={isReadOnly} />
      <TherapyPlanObjetivo isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
